export enum LicenseType {
  Trial = 1,
  EndUser = 2,
  Monthly = 3,
}
